<template>
    <PurchaseAdvisor></PurchaseAdvisor>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const PurchaseAdvisor = defineAsyncComponent(() =>
    import("../../components/Purchasing/PurchaseAdvisor/PurchaseAdvisor.vue")
);

export default {
    name: "PurchaseAdvisor_Purchashing",
    components: { PurchaseAdvisor, AuthLayout },
};
</script>
